module.exports = require('./AnchorContext');